<template>
    <hr
        :class="classes"
        class="o-spacer"
    >
</template>

<script>
export default {
    name: 'block-spacer',
    props: {
        classes: {
            type: String,
        },
    },
};
</script>
